var _desc, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgModule3Icon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M12,22.6C6.2,22.6,1.4,17.8,1.4,12S6.2,1.4,12,1.4 S22.6,6.2,22.6,12S17.8,22.6,12,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3,13.3c0.7,0.9,2,1.1,3,0.4c0.1-0.1,0.2-0.2,0.3-0.3l6.2-6.4l-0.3-0.5c-1.7-2.4-4.5-3.8-7.4-3.8 c-4.8,0-8.8,3.8-9.2,8.5h0V12c0,5.1,4.1,9.2,9.2,9.2s9.2-4.1,9.2-9.2v-0.7h-2.9v1.4h1.4C19.6,14.3,19,15.8,18,17l-1-1l-1,1l1,1 c-1.2,1-2.7,1.6-4.3,1.8v-1.4h-1.4v1.4C9.7,19.6,8.2,19,7,18l1-1l-1-1l-1,1c-1-1.2-1.6-2.7-1.8-4.3h1.4v-1.4H4.3 C4.6,8.9,6.7,7,9.2,7c1.6,0,3.1,0.7,4,2l-2.1,1c-1.1,0.5-1.5,1.8-1,2.8C10.2,13,10.2,13.2,10.3,13.3z M9.2,5.6 C8.5,5.6,7.7,5.7,7.1,6c3.2-2.6,7.9-2.3,10.7,0.8l-3.3,1.7C13.3,6.7,11.3,5.6,9.2,5.6z M11.7,11.4l3.7-1.9c0,0,0.3-0.3-2.9,3 c-0.3,0.3-0.7,0.3-1,0.1c-0.3-0.3-0.3-0.7-0.1-1C11.5,11.5,11.6,11.4,11.7,11.4L11.7,11.4z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgModule3Icon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/module3icon.7ca8df32.svg";
export { ForwardRef as ReactComponent };